import CallLogsProspectDrawerHeader from './call-logs-prospect-drawer-header';
import { callLogsProspectDrawerHeaderConnector } from './call-logs-prospect-drawer-header-redux';
import type { CallLogsProspectDrawerHeaderReduxProps } from './call-logs-prospect-drawer-header-redux';

export type { CallLogsProspectDrawerHeaderReduxProps } from './call-logs-prospect-drawer-header-redux';
export type IReportsProps = CallLogsProspectDrawerHeaderReduxProps;

export default callLogsProspectDrawerHeaderConnector(CallLogsProspectDrawerHeader);
